import React from 'react';
import DesignCarouselDesktop from '../DesignCarousel/DesignCarouselDesktop';
import DesignCarouselMobile from '../DesignCarousel/DesignCarouselMobile';

import './ProjectPageInfo.css'

const ProjectPageInfo = (props) => (
  <div className="page-content">
    <section className="project-page">
      <div className="heading-wrapper pt-3 pb-4 px-5">
        <h1 className="pt-2 pb-0">{props.title}</h1>
          <div className="dealer-info">
            <i className={props.icon}>{props.location}</i>
            <a className="ms-3 design-link" href={props.liveUrl} target="_BLANK" rel="noreferrer"> <i className="bi bi-box-arrow-up-right"></i>View Live Site</a>
          </div>
      </div>
      <div className="container-xl d-px-5">
        <div className="project-hero pt-5">
          <img src={props.heroImage} style={{ backgroundColor: "#F2F2F2" }}></img>
        </div>
        <div className="project-hero py-5">
          <img src={props.imacIpad} style={{ backgroundColor: props.backgroundColor, border: props.border  }}></img>
        </div>
        <div className="project-grid-container">
          <div className="project-hero">
            <img src={props.phoneOne} style={{ backgroundColor: props.backgroundColorTwo, border: props.border }}></img>
          </div>
          <div className="project-hero">
            <img src={props.phoneTwo} style={{ backgroundColor: props.backgroundColorTwo, border: props.border }}></img>
          </div>
        </div>
      </div>
      <div>
        <DesignCarouselDesktop images={props.desktopImages} />
        <DesignCarouselMobile images={props.mobileImages} />
      </div>
    </section>
  </div>
);

export default ProjectPageInfo;
